import MidiAction from './MidiAction.js';
import {TRACK_ROLL} from 'constants/midi-actions.js';

class TrackRollAction extends MidiAction {
    constructor(sequencerEngine) {
        super(TRACK_ROLL);
        this.sequencerEngine = sequencerEngine;
    }

    execute(value) {
        let roll = value > 127 / 2.0;

        this.sequencerEngine.trackRolling = roll;
    }
}

export default TrackRollAction;
